import { useId, type InputHTMLAttributes, type ReactNode } from "react";

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
  trailing?: ReactNode;
}

export function FieldInput({ label, hint, trailing, id, className = "", ...rest }: FieldProps) {
  const generatedId = useId();
  const fieldId = id ?? generatedId;
  return (
    <label className="field" htmlFor={fieldId}>
      <span className="field__label">{label}</span>
      <span className="field__control">
        <input id={fieldId} className={`field__input ${className}`.trim()} {...rest} />
        {trailing}
      </span>
      {hint && <span className="field__hint">{hint}</span>}
    </label>
  );
}
